import axios, { AxiosInstance, AxiosResponse } from 'axios'
import qs from 'qs'

export interface ApiService{
    get<Req, Res>(url: string, data?: Req): Promise<Res>;
    post<Req, Res>(url: string, data: Req): Promise<Res>;
    put<Req, Res>(url: string, data: Req): Promise<Res>;
    patch<Req, Res>(url: string, data: Req): Promise<Res>;
    delete<Req, Res>(url: string, data?: Req): Promise<Res>;
    getFile<Req, Res>(url: string, data?: Req): Promise<void>;
}

const client = axios.create({
    withCredentials: true,
    responseType: 'json',
    headers: {
        'Content-Type': 'application/json; charset=utf8'
    },
    transformResponse: (data) => {
        // костыль для обработки пустого тела ответа
        return data ? JSON.parse(data) : {}
    }
})

export default class Service implements ApiService {
    private client: AxiosInstance;

    constructor () {
        this.client = client
    }

    public async get<Request, Response> (url: string, data?: Request): Promise<Response> {
        const response: AxiosResponse<Response> = await this.client.get<Response>(url, {
            params: data,
            paramsSerializer: params => qs.stringify(params, { arrayFormat: 'brackets' })
        })

        return response.data
    }

    public async patch<Request, Response> (url: string, data: Request): Promise<Response> {
        const response = await this.client.patch<Response>(url, data)

        return response.data
    }

    public async post<Request, Response> (url: string, data: Request): Promise<Response> {
        const response = await this.client.post<Response>(url, data)

        return response.data
    }

    public async put<Request, Response> (url: string, data: Request): Promise<Response> {
        const response = await this.client.put<Response>(url, data)

        return response.data
    }

    public async delete<Request, Response> (url: string, data?: Request): Promise<Response> {
        const response = await this.client.delete<Response>(url, data)

        return response.data
    }

    public async getFile<Request, Response> (url: string): Promise<void> {
        const fileClient = axios.create({
            responseType: 'blob',
            headers: {
                'Content-Type': 'application/json; charset=utf8'
            }
        })

        const response = await fileClient.get<Response>(url)
        const fileUrl = window.URL.createObjectURL(response.data)
        const link = document.createElement('a')
        link.href = fileUrl
        link.setAttribute('download', 'act.pdf')
        document.body.appendChild(link)
        link.click()
    }
}
